import React, { useEffect, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { masterAPI } from "../../Masters/dataConfig";
import { axiosPrivate } from "../../../axios/axios";
import { Box, Divider, IconButton, Typography } from "@mui/material";
import { color } from "../../../StyleData/Config";
import { Clear } from "@mui/icons-material";
import tippy, { followCursor } from "tippy.js";
import "tippy.js/dist/tippy.css";
import moment from "moment";

function LabourTimeLine({ labourInfo, woDetail, handleCloseClick }) {
  const [calendarEvents, setCalendarEvents] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // getTimeLine(moment().subtract(15,"days"),moment().add(15,"days"));
  }, []);
function compareMomentObjects(startDateMoment, endDateMoment) {
    if (
      !moment.isMoment(startDateMoment) ||
      !moment.isMoment(endDateMoment) ||
      !startDateMoment.isValid() ||
      !endDateMoment.isValid()
    ) {
      return {
        areDifferentDates: false,
        areDifferentTimesOnSameDay: false,
        comparisonError: "Invalid Moment object or date",
      };
    }

    const areSameDate = startDateMoment.isSame(endDateMoment, "day");
    const areSameTime = startDateMoment.isSame(endDateMoment, "second"); // Compare down to the second

    return {
      areDifferentDates: !areSameDate,
      areDifferentTimesOnSameDay: areSameDate && !areSameTime,
    };
  }
  const getTimeLine = (startTime,endTime) => {
    setLoading(true);
    const getLink = masterAPI["workOrderTaskLabour"].labourSchedule;
    console.log(startTime,endTime)
    axiosPrivate
      .post(`${getLink}`, { startTime: startTime, endTime: endTime,labourId:labourInfo.labourId })
      .then((res) => {
        console.log(res);
        const filteredSchedule = res.data.result.map((entry) => {
           const comparValue = compareMomentObjects(
                        moment(entry.startTime),
                        moment(entry.endTime)
                      );
                      // console.log(item.title, comparValue);
          return {
          id: entry.id,
          title: entry.workOrder,
          start: entry.startTime,
           end: entry.endTime,
           allDay:
                comparValue.areDifferentDates ||
                (!comparValue.areDifferentDates &&
                  !comparValue.areDifferentTimesOnSameDay),
          // extendedProps: {
          //   employeeId: entry.employeeId,
          //   task: entry.task,
          // },
          // backgroundColor: entry.employeeId % 2 === 0 ? '#e0f7fa' : '#f1f8e9',
          // borderColor: entry.employeeId % 2 === 0 ? '#00bcd4' : '#8bc34a',
          // textColor: '#212121',
        }});
        console.log(filteredSchedule)
        setCalendarEvents(filteredSchedule);
        setLoading(false);
      })
      .catch((e) => {
        setCalendarEvents([]);
        setLoading(false);
        console.log(e);
      });
  };

  const handleDatesSet = (arg) => {
    // Triggered when user clicks "next", "prev", or changes view
    const start = arg.start;
    const end = arg.end;
    console.log(arg)
    getTimeLine(start,end)

  };

  const handleEventDidMount = (info) => {
      tippy(info.el, {
        content:  info.event.title, // Use a custom property or the title
        interactive: true,
        allowHTML: true, // If your description might contain HTML
        placement: "top",
        followCursor: "horizontal",
        delay: [100, 0],
      });
    };

  return (
    <div>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Typography
          sx={{
            color: color.masterDialogTitleColor,
            fontSize: color.masterDialogFontSize,
          }}
        >
          {labourInfo.labourCode + " - " + labourInfo.labourName}
        </Typography>
        <IconButton onClick={handleCloseClick}>
          <Clear />
        </IconButton>
      </Box>
      <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }} />
      <FullCalendar
        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
        initialView="timeGridWeek"
        // initialDate={woDetail.start}
        headerToolbar={{
          left: "prev,next today",
          center: "title",
          right: "dayGridMonth,timeGridWeek,timeGridDay",
        }}
        dayHeaderFormat={{ weekday: "short", day: "numeric", month: "short" }} // Custom format
        // You can try other formats like:
        // dayHeaderFormat={{ weekday: 'long', day: 'numeric' }} // e.g., Monday 5
        // dayHeaderFormat={{ day: 'numeric', month: 'numeric' }} // e.g., 5/2
        // dayHeaderFormat={{ weekday: 'narrow', day: 'numeric' }} // e.g., M 5
        // dayHeaderFormat={{ weekday: 'short', day: '2-digit' }} // e.g., Mon 05
        events={calendarEvents}
        datesSet={handleDatesSet}
        eventDidMount={handleEventDidMount}
        eventContent={(arg) => (
          <div>
            <b>{arg.event.title}</b>
          </div>
        )}
        // eventClick={(info) => {
        //   alert(`Event: ${info.event.title}\nTask: ${info.event.extendedProps.task || 'N/A'}`);
        // }}
        dateClick={(info) => {
          console.log("Clicked on date:", info.dateStr);
        }}
        editable={false}
        selectMirror={true}
        dayMaxEvents={true}
        weekends={true}
        slotMinTime="07:00:00"
        slotMaxTime="20:00:00"
        height="auto"
      />
    </div>
  );
}

export default LabourTimeLine;
